import { themeFonts } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link from "@insite/mobius/Link/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface CartLinesListStyles {
    wrapper?: InjectableCss;
}

export const orderLinesListStyles: CartLinesListStyles = {
    wrapper: {
        css: css`
            h4 {
                font-family: ${themeFonts.fontFamilyMuseoSans};
            }
            .link {
                display: block;
            }
        `,
    },
};

const GMBudgetLinks: React.FunctionComponent = () => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        const customerInfoWrapElements = document.querySelectorAll(".customer-info-wrap");
        const customerBudgetTable = document.querySelectorAll(".budget-table-wrap");
        const headerUserName = document.querySelector('.headerUserName');

        customerInfoWrapElements.forEach(element => {
            element.classList.add("active");
        });
        customerBudgetTable.forEach(element => {
            element.classList.add("active");
        });

        if (headerUserName) {
            headerUserName.classList.add("active");
        }
    };

    const styles = orderLinesListStyles;
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h4" id="isPasted">
                {translate("Budgets")}
            </Typography>
            <Link className="link" onClick={handleClick} id="budget-display" href="#">
                {translate("Budget Display")}
            </Link>

            <Link className="link" href="/MyAccount/Budget">
                {translate("Budget Setup")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: GMBudgetLinks,
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
